<template>
    <div style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
        <div
            v-if="compassDirection!==null && arrowDirection!==null && gyro"
            v-show="directionDiff < 30 && directionDiff > -30"
            class="arrow-wrapper"
            :style="transform()"
        >
            <MArStepIcon :style="{ transform: `rotateY(${this.directionDiff*-1.8}deg)` }"/>
            <img :style="{ transform: `rotateX(${rotateX()}deg) ` }" src="../../../assets/images/ar/3D-arrow.png" class="camera__arrow"  >
        </div>
        <div v-if="$route.query.debug" style="position: fixed; z-index: 99999999999999; top: 10vh; left: 40px;">
            {{ arrowDirection }} <br/>
            {{ compassDirection }} <br/>
            {{ directionDiff }} <br/>
            {{ rotateX() }} <br/>
            Steps: {{ stepsCount }} <br/>
        </div>
    </div>
</template>

<script>
import MArStepIcon from "@/components/molecules/m-ar-step-icon/m-ar-step-icon";
export default {
    name: 'MArArrow',
    components: {MArStepIcon},
    props: {
        distance: {
            type: Number,
            default: null
        },
        compassDirection: {
            type: Number,
            default: null
        },
        gyro: {
            type: Object,
            default: null
        },
        stepsCount: {
            type: Number,
            default: null
        },
        arrowDirection: {
            type: Number,
            default: null
        },
        directionDiff: {
            type: Number,
            default: null
        },
    },
    methods:{
        transform () {
            //skewX(${this.directionDiff*-1}deg)
            const translateY = this.gyro?.pitch > 86 ? this.gyro?.pitch-86 : 0;
            return { transform: `translateX(${this.directionDiff*1.8}vw) translateY(${translateY}vh) translateZ(200px)`}
        },
        rotateX(){
            return this.gyro?.pitch-30;
        }
    }
}
</script>

<style lang="scss" src="./theme.scss" />
